import React from 'react';
import Dialog from '@/ui/dialogs/Dialog';
import { closeRejectDialog, rejectBonus } from '@/luckyWheel/h&s';
import LuckyWheelConfirmReject from 'nike-ui/src/components/lucky-wheel/LuckyWheelConfirmReject';

const LuckyWheelRejectDialog = () => {
    return (
        <Dialog className="confirm-dialog" modal>
            <LuckyWheelConfirmReject
                handleReject={rejectBonus}
                handleBack={() => closeRejectDialog(true)}
                closeDialogWhenError={() => closeRejectDialog(false)}
            />
        </Dialog>
    );
};

export default LuckyWheelRejectDialog;
